import React from "react";

import "./LadingPage.scss";

import { Block } from "@randajan/jet-react/dom/block";
import { Caption } from "@randajan/jet-react/dom/caption";

import { Numbers } from "./Numbers/Numbers";
import { Article } from "../../elements/Article/Article";
import { NextGame } from "./NextGame/NextGame";
import { Locale } from "../../assets/Locale";
import { Say } from "../../../arc/locale/consts";
import { Reviews } from "./Reviews/Reviews";


export const LadingPage = (props)=>{
    const {} = props;

    const say = Locale.use();
    const notePrefix = Say.id("landing", "note");

    return (
        <Block className="LandingPage" level={0}>
            <div className="slab main wall -tall -column">
                <div className="motto">
                    <Caption>{say("webH1")}</Caption>
                    <p>{say.random(k=>k.startsWith(notePrefix))}</p>
                    <p>{say("landingClaim")}</p>
                </div>
                <NextGame/>
            </div>

            <Block className="slab numbers wall -column">
                <Numbers/>
            </Block>
            <Article className="slab paragraph wall -tall -column" storeId={`landingPreview`}/>
            <Reviews/>
            <Article className="slab paragraph wall -tall -column" storeId={`landingGameplay`}/>
            <Article className="slab paragraph wall -column" storeId={`landingForWho`}/>
        </Block>
    );
};
